export const initialState = {
    name: '',
    pattern: '',
    isActive: true,
};

export const specialNumbersPath = '/special-numbers';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Special Numbers', path: specialNumbersPath },
    { label: 'Add Special Number', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Special Numbers', path: specialNumbersPath },
    { label: 'Edit Special Number', path: '' },
];

export const addHeader = 'Special Number Details';
export const editHeader = 'Edit Special Number Details';
